import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from './ui/Button';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past the hero section (approx 600px)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <AnimatePresence data-id="element-341">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} className="fixed bottom-0 left-0 right-0 p-4 bg-white/90 backdrop-blur-md border-t border-gray-200 shadow-[0_-10px_40px_rgba(0,0,0,0.1)] z-50 md:hidden" data-id="element-342">
          <div className="flex items-center justify-between gap-4 max-w-md mx-auto" data-id="element-343">
            <div className="flex flex-col" data-id="element-344">
              <span className="text-xs text-gray-500 font-medium line-through" data-id="element-345">
                $114
              </span>
              <span className="text-xl font-black text-brand-charcoal leading-none" data-id="element-346">
                $9.99
              </span>
            </div>
            <Button onClick={scrollToPricing} size="normal" className="flex-1 py-3" data-id="element-347">
              SÍ QUIERO
            </Button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}